<lib-table [tableColumns]="inactiveUsersColumns" [api]="api" 
    [searchUIOptions]="searchUIOptions" [resourceMessages]="resourceMessages" [addNewButton]="false" [title]="title"
    [showCount]="false"></lib-table>